export const SET_AUTHENTICATING = 'SET_AUTHENTICATING';

export const SET_LOADING = 'SET_LOADING';

export const SET_LOADING_SUBSTANCES = 'SET_LOADING_SUBSTANCES';

export const SET_LOADING_PROFILES = 'SET_LOADING_PROFILES';

export const SET_MESSAGE = 'SET_MESSAGE';

export const SET_OFFLINE_DOWNLOAD_COMPLETE = 'SET_OFFLINE_DOWNLOAD_COMPLETE';


export const setAuthenticating = val => {
    return {
        type: SET_AUTHENTICATING,
        payload: val
    }
};

export const setLoading = val => {
    return {
        type: SET_LOADING,
        payload: val
    }
};

export const setLoadingSubstances = val => {
    return {
        type: SET_LOADING_SUBSTANCES,
        payload: val
    }
};

export const setLoadingProfiles = val => {
    return {
        type: SET_LOADING_PROFILES,
        payload: val
    }
};

export const setMessage = message => {
    return {
        type: SET_MESSAGE,
        payload: message
    }
};

export const setOfflineDownloadComplete = val => {
    return {
        type: SET_OFFLINE_DOWNLOAD_COMPLETE,
        payload: val
    }
}


